import { useRouter } from 'next/router'

export const HideIfPathMatches = ({
  children,
  paths: pathPrefixes = [],
}: {
  children: React.ReactNode
  paths?: string[]
}) => {
  const { asPath } = useRouter()

  if (pathPrefixes.some((path) => asPath.startsWith(path))) {
    return null
  }

  return <>{children}</>
}
